import { useState, useEffect, useRef, useContext, useMemo } from "react";
import { format, differenceInDays, addDays } from "date-fns";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import PreEvento from "./PreEvento";
import {
  managerClonerBetHome,
  timeSurebetAllowed,
  modelPopUpSettings,
} from "../global/GlobalVariables";
import { checkLogin } from "../global/GlobalFunctions";
import AoVivo from "./AoVivo";
import Cookies from "js-cookie";
import GeneratorLinkSurebet, {
  GeneratorLinkSurebet_000,
} from "./functions/GeneratorLinkExtension";
import { Context } from "../App";
import { filterMarketEvent } from "./functions/FunctionsGames";
import {
  URL_SAFE_BET,
  URL_DADOSPRE,
  URL_SAFE_BET_TRES,
  URL_SAFE_BET_GLOBAL,
} from "./variables/VariablesGame";
import { decrypt_game } from "./functions/FunctionsGames";
import { esports } from "./variables/VariablesFilterSurebet";
import { Warn } from "./sub-componentes/game/Warn";

const timeObject = {
  "6 Horas": 60 * 1000 * 60 * 6,
  "12 Horas": 60 * 1000 * 60 * 12,
  "16 Horas": 60 * 1000 * 60 * 16,
  "1 Dia": 60 * 1000 * 60 * 24,
};

let orderloop = [
  "first_home_bet",
  "second_home_bet",
  "third_home_bet",
  "fourth_home_bet",
  "fifth_home_bet",
  "sixth_home_bet",
  "seventh_home_bet",
  "eighth_home_bet",
  "ninth_home_bet",
  "tenth_home_bet",
];

function MainBets(props) {
  const {
    valueMin,
    valueMax,
    betHome,
    sports,
    timeEvent,
    itemsTrash,
    setItemsTrash,
    statusMode,
    controllerLocalStorage,
    setValueMin,
    setValueMax,
    setBetHome,
    quantityBetHomeEnabled,
    setQuantityBetHomeEnabled,
    setSports,
    quantitySportsEnabled,
    setQuantitySportsEnabled,
    setTimeEvent,
    notificationVolume,
    isLoggedIn,
    user,
    setlistBehomeEnableds,
    setentradasLigth,
    entradasLigth,
    setentradasPro,
    entradasPro,
    setAparecerProf,
    setAparecerVivo,
    setAparecerLight,
    setAparecerPro,
    AparecerProf,
    AparecerVivo,
    AparecerLight,
    AparecerPro,
    filterOrder,
    setFilterOrder,
    requiredBetHome,
    setRequiredBetHome,
    plansType,
    setCanGetOperation,
  } = props;
  const [apitofisrt, setApitoFirst] = useState(false);
  const [userDatas, setUsersData] = useState(user);
  const iconelixeira = `${process.env.PUBLIC_URL}/images/iconlixeira.png`;
  const [settingsPopUpsJSON, setSettingsPopUpsJSON] = useState(
    localStorage.getItem("popUpSettings") !== null
      ? localStorage.getItem("popUpSettings")
      : JSON.stringify(modelPopUpSettings),
  );

  const [checkUpdate, setCheckUpdate] = useState("1");
  const [checkOpen, setCheckOpen] = useState("1");

  const [data, setData] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [newKeySymbol, setNewKeys] = useState([]);
  const oldData = useRef({});
  const [statusTrash, setStatusTrash] = useState(false);
  const [permissaoaovivo, setPermissaoaovivo] = useState(false);

  const [colunaAtiva, setColunaAtiva] = useState("preEvento");
  const [diasRestantes, setdiasRestantes] = useState(0);
  const [popUpBloqueado, setPopUpBloqueado] = useState(false);
  const [notificationTime, setNotificationTime] = useState(null);
  const [buttonSpreadsheet, setButtonSpreadsheet] = useState(false);

  const navigate = useNavigate();
  const [url, setUrl] = useState("");
  const playSound = useRef(true);

  const canGetSurebetLight = useRef(true);
  const canGetSurebetPro = useRef(true);
  const isLiveEvent = useRef(false);

  const [warningTimeSurebet, setWarningTimeSurebet] = useState([]);

  const {
    marketsUnselected,
    clearOldSurebet,
    blacklistWords,
    accountFeatures,
    threeHouseEntryisActivated,
    entradasGlobal,
  } = useContext(Context);

  async function checkCanGetOperation() {
    let responses = {};
    await checkLogin(true).then((data) => {
      if (
        data["user_data"] !== undefined &&
        data["user_data"] !== null &&
        typeof data["user_data"] === "object"
      ) {
        if (data === false) {
          setCanGetOperation(false);
        }
        responses["data"] = data["user_data"];
        let accountFeaturesReceived = JSON.parse(
          responses.data.account_features,
        );
        let hasLightMode = accountFeaturesReceived.includes("light");
        setCanGetOperation(hasLightMode);
      } else {
        setCanGetOperation(false);
      }
    });
  }

  const toggleColuna = (coluna) => {
    setColunaAtiva(coluna);

    let planName = String(
      userDatas.tipo_de_plano.replace("Arbritagem Bet ", ""),
    );

    const partes = planName.split(" ");

    const tipo = partes[0].trim();

    if (tipo === "Light" || tipo.includes("Ao Vivo")) {
      setPermissaoaovivo(true);
    }
  };

  function notifyBet(bet) {
    const song = `${process.env.PUBLIC_URL}/apitodefutebol.mp3`;
    const audioElement = new Audio(song);

    const playNotificationSound = () => {
      audioElement.volume = notificationVolume;
      audioElement.play().catch((error) => {
        console.error("Erro ao reproduzir o som:", error);
      });
    };

    if (playSound.current === true) {
      playSound.current = false;
      playNotificationSound();
      if ("Notification" in window) {
        const currentTime = format(new Date(), "HH:mm:ss");
        setNotificationTime(currentTime);
      }

      setTimeout(() => {
        playSound.current = true;
      }, 3000);
    }
  }

  function checkBetHomeEnabledAndNotify(game) {
    const betHomeEnabled = JSON.parse(localStorage["listBehomeEnabled"]);

    if (typeof game === "undefined") {
      return false;
    }

    for (
      let indexOrderLoop = 0;
      indexOrderLoop < orderloop.length;
      indexOrderLoop++
    ) {
      let keyOrderBethome = orderloop[indexOrderLoop];

      if (keyOrderBethome in game) {
        let betHomeLower = game[keyOrderBethome]["name_bet_home"].toLowerCase();

        let betHomeIsEnable = betHomeEnabled.includes(betHomeLower);

        if (betHomeIsEnable === false) {
          return false;
        }
      }
    }

    return true;
  }

  function openPopUpCalculator(value) {
    localStorage.removeItem("dataCalculator");
    if (typeof data !== "string") {
      localStorage.setItem("dataCalculator", JSON.stringify(data));
    } else {
      localStorage.setItem("dataCalculator", data);
    }
    const url = `${window.location.origin}/calculator/${value}`;
    const windowName = "popupCalculator";

    if (window[windowName] && !window[windowName].closed) {
      window[windowName].onhashchange = function () {
        window[windowName].location.reload();
      };

      window[windowName] = window.open(url, windowName, "popup");
      window[windowName].focus();
      return true;
    } else {
      const windowFeatures = "width=800,height=460";
      window[windowName] = window.open(url, windowName, windowFeatures);

      if (!window[windowName]) {
        setPopUpBloqueado(true);
        alert(
          "Pop-up bloqueado! Por favor, permita pop-ups para este site nas configurações do seu navegador.",
        );
      }
      window[windowName].focus();
      return true;
    }
  }
  function openPopUpBet(value) {
    const url = `${value}`;
    const windowName = "popupWindow";
    const windowName2 = "popupWindow2";

    if (
      window[windowName] &&
      !window[windowName].closed &&
      window[windowName2] &&
      !window[windowName2].closed
    ) {
      if (checkUpdate === "1") {
        window[windowName].location.href = url;
        setCheckUpdate("2");
      } else {
        window[windowName2].location.href = url;
        setCheckUpdate("1");
      }
    } else {
      if (checkOpen === "1") {
        setCheckOpen("2");
        const windowFeatures = "width=800,height=460";
        window[windowName] = window.open(url, windowName, windowFeatures);
        if (!window[windowName]) {
          setPopUpBloqueado(true);
          alert(
            "Pop-up bloqueado! Por favor, permita pop-ups para este site nas configurações do seu navegador.",
          );
        }
      }
      if (checkOpen === "2") {
        setCheckOpen("1");

        const windowFeatures = "width=800,height=460";
        window[windowName2] = window.open(url, windowName2, windowFeatures);
        if (!window[windowName2]) {
          setPopUpBloqueado(true);
          alert(
            "Pop-up bloqueado! Por favor, permita pop-ups para este site nas configurações do seu navegador.",
          );
        }
      }
    }
  }

  useEffect(() => {
    localStorage.setItem("popUpSettings", settingsPopUpsJSON);
  }, [settingsPopUpsJSON]);

  function openPopUpAllBet(value, value2) {
    const url = `${value}`;
    const url2 = `${value2}`;
    const windowName = "popupWindowAll";
    const windowName2 = "popupWindowAll2";

    let widthPopUpOne = 800;
    let heightPopUpOne = 460;
    let leftPopUpOne = 0;
    let topPopUpOne = 0;

    let widthPopUpTwo = 800;
    let heightPopUpTwo = 460;
    let leftPopUpTwo = 0;
    let topPopUpTwo = 0;

    try {
      let popUpSettings = JSON.parse(settingsPopUpsJSON);
      widthPopUpOne = popUpSettings[windowName]["width"];
      heightPopUpOne = popUpSettings[windowName]["height"];
      leftPopUpOne = popUpSettings[windowName]["left"];
      topPopUpOne = popUpSettings[windowName]["top"];

      widthPopUpTwo = popUpSettings[windowName2]["width"];
      heightPopUpTwo = popUpSettings[windowName2]["height"];
      leftPopUpTwo = popUpSettings[windowName2]["left"];
      topPopUpTwo = popUpSettings[windowName2]["top"];
    } catch {
      setSettingsPopUpsJSON(JSON.stringify(modelPopUpSettings));

      widthPopUpOne = 800;
      heightPopUpOne = 460;
      leftPopUpOne = 0;
      topPopUpOne = 0;
      widthPopUpTwo = 800;
      heightPopUpTwo = 460;
      leftPopUpTwo = 0;
      topPopUpTwo = 0;
    }

    if (
      window[windowName] &&
      !window[windowName].closed &&
      window[windowName2] &&
      !window[windowName2].closed
    ) {
      window[windowName] = window.open("about:blank", windowName, `popup`);
      window[windowName2] = window.open("about:blank", windowName2, `popup`);

      setTimeout(() => {
        try {
          widthPopUpOne = window[windowName].innerWidth;
          heightPopUpOne = window[windowName].innerHeight;
          leftPopUpOne = window[windowName].screenX;
          topPopUpOne = window[windowName].screenY;

          widthPopUpTwo = window[windowName2].innerWidth;
          heightPopUpTwo = window[windowName2].innerHeight;
          leftPopUpTwo = window[windowName2].screenX;
          topPopUpTwo = window[windowName2].screenY;
          let popUpSettings = { popupWindowAll: {}, popupWindowAll2: {} };

          popUpSettings[windowName]["width"] = widthPopUpOne;
          popUpSettings[windowName]["height"] = heightPopUpOne;
          popUpSettings[windowName]["left"] = leftPopUpOne;
          popUpSettings[windowName]["top"] = topPopUpOne;

          popUpSettings[windowName2]["width"] = widthPopUpTwo;
          popUpSettings[windowName2]["height"] = heightPopUpTwo;
          popUpSettings[windowName2]["left"] = leftPopUpTwo;
          popUpSettings[windowName2]["top"] = topPopUpTwo;

          setSettingsPopUpsJSON(JSON.stringify(popUpSettings));
        } catch {
          console.log("Erro");
        }
        window[windowName].close();
        window[windowName2].close();

        window[windowName] = window.open(
          url,
          windowName,
          `width=${widthPopUpOne},height=${heightPopUpOne}, top=${topPopUpOne},left=${leftPopUpOne}`,
        );
        window[windowName2] = window.open(
          url2,
          windowName2,
          `width=${widthPopUpTwo},height=${heightPopUpTwo}, top=${topPopUpTwo},left=${leftPopUpTwo}`,
        );
      }, 3000);

      return;
    } else {
      window[windowName] = window.open(
        url,
        windowName,
        `width=${widthPopUpOne},height=${heightPopUpOne}, top=${topPopUpOne},left=${leftPopUpOne}`,
      );
      window[windowName2] = window.open(
        url2,
        windowName2,
        `width=${widthPopUpTwo},height=${heightPopUpTwo}, top=${topPopUpTwo},left=${leftPopUpTwo}`,
      );
      if (!window[windowName2] || !window[windowName]) {
        setPopUpBloqueado(true);
        alert(
          "Pop-up bloqueado! Por favor, permita pop-ups para este site nas configurações do seu navegador.",
        );
      }
      window[windowName].focus();
      window[windowName2].focus();

      return;
    }
  }

  function checkBetHomeEnabled(game) {
    const betHomeEnabledString = JSON.parse(localStorage["listBehomeEnabled"]);
    let listBetHomeRequired = [];

    if (typeof game === "undefined") {
      return false;
    }

    if (betHomeEnabledString) {
      const betHomeEnabled = betHomeEnabledString;

      for (
        let indexOrderLoop = 0;
        indexOrderLoop < orderloop.length;
        indexOrderLoop++
      ) {
        let keyOrderBethome = orderloop[indexOrderLoop];

        if (keyOrderBethome in game) {
          let nameBetHome =
            game[keyOrderBethome]["name_bet_home"].toLowerCase();

          if (
            ["kto", "betwarrior"].includes(nameBetHome) === true &&
            esports.includes(game[keyOrderBethome]["sport"]) === true
          ) {
            return false;
          } else if (betHomeEnabled.includes("betboo")) {
            if (nameBetHome === "betboo") {
              game[keyOrderBethome]["name_bet_home"] = "Betboo";
              game[keyOrderBethome]["url_bet_home"] = game[keyOrderBethome][
                "url_bet_home"
              ].replace(".sportingbet.", ".br.betboo.");
              game[keyOrderBethome]["url_bet"] = game[keyOrderBethome][
                "url_bet"
              ].replace(".sportingbet.", ".br.betboo.");
            }
          } else if (betHomeEnabled.includes("sportingbet")) {
            if (nameBetHome === "betboo") {
              game[keyOrderBethome]["name_bet_home"] = "Sportingbet";

              game[keyOrderBethome]["url_bet_home"] = game[keyOrderBethome][
                "url_bet_home"
              ].replace(".br.betboo.", ".sportingbet.");
              game[keyOrderBethome]["url_bet"] = game[keyOrderBethome][
                "url_bet"
              ].replace(".br.betboo.", ".sportingbet.");
            }
          } else if (betHomeEnabled.includes("boddog (en)")) {
            if (nameBetHome === "boddog") {
              game[keyOrderBethome]["url_bet_home"] = game[keyOrderBethome][
                "url_bet_home"
              ].replace("/basketball/", "/basquete/");
              game[keyOrderBethome]["url_bet_home"] = game[keyOrderBethome][
                "url_bet"
              ].replace("/superleague/", "/superliga/");
            }
          }

          let nameBetHomeLower = nameBetHome;
          if (
            managerClonerBetHome["allBetHomeAbleToClone"].includes(
              nameBetHomeLower,
            )
          ) {
            for (
              let i = 0;
              i <
              managerClonerBetHome[nameBetHomeLower]["allBetHomeClone"].length;
              i++
            ) {
              let nameBetHomeToClone =
                managerClonerBetHome[nameBetHomeLower]["allBetHomeClone"][i];
              if (
                betHomeEnabled.includes(nameBetHomeToClone) &&
                !betHomeEnabled.includes(nameBetHomeLower)
              ) {
                game[keyOrderBethome]["name_bet_home"] =
                  managerClonerBetHome[nameBetHomeLower][nameBetHomeToClone][
                    "nameBetHome"
                  ];
                break;
              }
            }
          }

          let betHomeIsEnable = betHomeEnabled.includes(nameBetHome);
          if (betHomeIsEnable === false) {
            return false;
          }
          //else if ('stake' === nameBetHomeLower){
          //  let newStakeUrl = shortenStakeUrl(game[keyOrderBethome]["url_bet"]);
          //  game[keyOrderBethome]["url_bet"] = newStakeUrl;
          //}

          let betHomeLower = nameBetHome.toLowerCase();
          listBetHomeRequired.push(requiredBetHome.includes(betHomeLower));
        }
      }

      if (requiredBetHome.length > 0) {
        return listBetHomeRequired.includes(true);
      } else {
        return true;
      }
    } else {
      console.error("A chave listBehomeEnabled não existe ou está vazia.");
    }
  }

  function checkQuantityBetEnabled(hideBets, filterBetHome) {
    let countBetHide = -1;
    let keySurebet = Object.keys(hideBets);
    for (
      let indexhideBets = 0;
      indexhideBets < keySurebet.length;
      indexhideBets++
    ) {
      let hideBet = hideBets[keySurebet[indexhideBets]];

      countBetHide += checkBetHomeEnabled(hideBet["main"]) === true ? 1 : 0;
    }
    return countBetHide;
  }

  function managerBetView(fullGame, gameMain = []) {
    let listGames = gameMain.length > 0 ? gameMain : fullGame["group_events"];

    let resultBetHomeChecked = checkBetHomeEnabled(fullGame["main"]);

    let quantityHideBet = 0;
    let textHideBet = "";
    if (listGames) {
      for (
        let indexhideBets = 0;
        indexhideBets < listGames.length;
        indexhideBets++
      ) {
        let hideBet = listGames[indexhideBets]["main"];

        resultBetHomeChecked = checkBetHomeEnabled(hideBet);
        if (resultBetHomeChecked) {
          quantityHideBet = checkQuantityBetEnabled(fullGame["group_events"]);
          if (quantityHideBet > 0) {
            textHideBet = `+ ${quantityHideBet} aposta segura para este evento`;
          }

          fullGame["main"] = hideBet;
          fullGame["main"]["similar_event"] = textHideBet;
          return fullGame;
        }
      }
    }
    return {};
  }

  function betHomeView(fullGame) {
    let bet = managerBetView(fullGame, [fullGame]);
    if (Object.keys(bet).length === 0) {
      bet = managerBetView(fullGame, []);
    }
    return bet;
  }

  function eventTrash(nameEvente, statusEvent) {
    if (!statusEvent) {
      setItemsTrash((current) => [...current, nameEvente]);
    } else {
      setItemsTrash((surebetTrash) => {
        return surebetTrash.filter((item) => item !== nameEvente);
      });
    }
  }

  function handleClick(value) {
    let allUrlSurebet = {};

    try {
      for (let i = 0; i < orderloop.length; i++) {
        let itemOrderLoop = orderloop[i];
        if (itemOrderLoop in data[value]["main"]) {
          let urlExt = Object.prototype.hasOwnProperty.call(
            data[value]["main"][itemOrderLoop],
            "description_data_market",
          )
            ? GeneratorLinkSurebet(
                data[value]["main"][itemOrderLoop],
                data[value]["main"]["profit"],
              )
            : GeneratorLinkSurebet_000(
                data[value]["main"][itemOrderLoop],
                data[value]["main"]["profit"],
              );
          allUrlSurebet[itemOrderLoop] = urlExt;
        }
      }
      
      openPopUpAllBet(
        allUrlSurebet["first_home_bet"],
        allUrlSurebet["second_home_bet"],
      );
      openPopUpCalculator(value);
    } catch (error) {
      console.error("Ocorreu um erro:", error);
    }
  }

  const handleLinkClick = (value, nameOrder) => {
    const betHomeEnabled = JSON.parse(localStorage["listBehomeEnabled"]);
    let novaUrl = data[value]["main"][nameOrder]["url_bet"];

    if (novaUrl.includes("/en/")) {
      novaUrl = novaUrl.replace("/en/", "/pt/");
    }
    if (betHomeEnabled.includes("betboo")) {
      novaUrl = novaUrl.replace(".sportingbet.", ".br.betboo.");
    } else if (betHomeEnabled.includes("sportingbet")) {
      novaUrl = novaUrl.replace(".br.betboo.", ".sportingbet.");
    } else if (betHomeEnabled.includes("kto")) {
      novaUrl = novaUrl.replace(".kto", ".estrelabet.");
    } else if (betHomeEnabled.includes("bodog (en)")) {
      novaUrl = novaUrl.replace("/basketball/", "/basquete/");
      novaUrl = novaUrl.replace("/superleague/", "/superliga/");
    }

    setUrl(novaUrl);
  };

  const getResponse = async (fullData, newValueData) => {
    for (let keyObject in fullData) {
      let valueObject = fullData[keyObject];

      let newValueDataObject = betHomeView(valueObject);

      if (Object.keys(newValueDataObject).length === 0) {
        continue;
      }

      let profit = newValueDataObject["main"]["profit"];

      if (typeof profit === "string") {
        profit = profit.replace("%", "").replace(",", ".");
      } else {
        profit = profit.toString();
      }

      profit = parseFloat(profit);

      if (!(valueMin <= profit && profit <= valueMax)) {
        if (valueMax < 0) {
          setValueMax(valueMax * -1);
        }
        continue;
      } else if (
        !JSON.parse(localStorage.listSportsEnabled).includes(
          newValueDataObject["main"]["first_home_bet"]["sport"].toLowerCase(),
        )
      ) {
        continue;
      } else if (timeEvent !== "Qualquer Horário") {
        let jumpLoop = false;
        for (let i = 0; i < orderloop.length; i++) {
          let order = orderloop[i];

          if (order in newValueDataObject["main"]) {
            let timeGame = parseInt(
              newValueDataObject["main"][order]["time_milliseconds"],
            );
            let timeCalculated = timeGame - new Date().getTime();

            if (timeCalculated >= timeObject[timeEvent]) {
              jumpLoop = true;
              break;
            }
          }
        }
        if (jumpLoop) {
          continue;
        }
      }
      if (itemsTrash.includes(keyObject) === !statusTrash) {
        continue;
      }

      let check = checkBetHomeEnabledAndNotify(newValueDataObject["main"]);
      if (!check) {
        break;
      }

      let result_filterMarket = filterMarketEvent(
        marketsUnselected,
        blacklistWords,
        newValueDataObject["main"],
      );
      if (result_filterMarket === false) {
        continue;
      }

      newValueData[keyObject] = newValueDataObject;
    }

    let newObjectOrdenated = {};
    let objectKeyProfit = {};
    let listProfitToOrdenate = [];
    let keysObject = Object.keys(newValueData);

    for (let i = 0; i < keysObject.length; i++) {
      let keyObject = newValueData[keysObject[i]]["main"]["profit"]
        .toString()
        .replaceAll(",", ".")
        .replaceAll("%", "");

      if (objectKeyProfit[Number(keyObject).toString()] === undefined) {
        objectKeyProfit[Number(keyObject).toString()] = [];
      }

      objectKeyProfit[Number(keyObject).toString()].push(keysObject[i]);

      listProfitToOrdenate.push(Number(keyObject));
    }

    listProfitToOrdenate
      .sort(function (a, b) {
        return a - b;
      })
      .reverse();

    for (let i = 0; i < listProfitToOrdenate.length; i++) {
      let keyValueProfit = listProfitToOrdenate[i].toString();
      newObjectOrdenated[objectKeyProfit[keyValueProfit][0]] =
        fullData[objectKeyProfit[keyValueProfit][0]];
      objectKeyProfit[keyValueProfit].splice(0, 1);
    }

    setData(newObjectOrdenated);
    return newObjectOrdenated;
  };

  async function getData(url) {
    try {
      const b4726486 = Cookies.get("b4726486");
      const response = await axios.post(
        url,
        {
          b652242: b4726486,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      if (response.status !== 200) throw new Error("Falha na requisição");
      try {
        let x12 = decrypt_game(response.data);
        return x12;
      } catch {
        return response.data;
      }
    } catch (error) {
      console.log("Erro", error);
    }
  }

  async function getData_000(url) {
    try {
      const b4726486 = Cookies.get("b4726486");
      const response = await axios.post(
        url,
        {
          b652242: b4726486,
        },

        {
          timeout: 30000,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      if (response.status !== 200) throw new Error("Falha na requisição");
      try {
        let x12 = await response.json();

        return x12;
      } catch {
        return response.data;
      }
    } catch (error) {
      console.log("Erro", error);
    }
  }

  const fetchData = async () => {
    if (
      canGetSurebetLight.current === true &&
      canGetSurebetPro.current === true &&
      isLiveEvent.current === false
    ) {
      try {
        const newData = {};

        if (clearOldSurebet.current === true) {
          oldData.current.value = JSON.stringify({});
          setData([]);
          setFullData([]);
          clearOldSurebet.current = false;
        }
        const oldDataJsonConvertted = JSON.parse(oldData.current.value || "{}");

        let canShowLight = accountFeatures.current.includes("light");
        let canShowPro = accountFeatures.current.includes("pro");
        let canShowGlobal = accountFeatures.current.includes("global");

        if (entradasLigth && canShowLight) {
          canGetSurebetLight.current = false;

          let dataLightMode = await getData_000(URL_SAFE_BET);

          if (dataLightMode["error"] === true) {
            checkCanGetOperation();
          } else {
            Object.assign(newData, dataLightMode);
          }
          
          canGetSurebetLight.current = true;
          dataLightMode = null;
        }
        
        if (entradasGlobal && canShowGlobal) {
          let dataGlobalMode = await getData_000(URL_SAFE_BET_GLOBAL);

          if (dataGlobalMode["error"] === true) {
            checkCanGetOperation();
          } else {
            Object.assign(newData, dataGlobalMode);
          }
        }

        if (entradasPro && canShowPro) {
          canGetSurebetPro.current = false;
          let dataProMode = await getData_000(URL_DADOSPRE);

          if (dataProMode["error"] === true) {
            checkCanGetOperation();
          } else {
            Object.assign(newData, dataProMode);
          }
          canGetSurebetPro.current = true;
          dataProMode = null;
        }
        if (canShowPro && threeHouseEntryisActivated) {
          canGetSurebetPro.current = false;
          let dataTreesMode = await getData_000(URL_SAFE_BET_TRES);

          if (dataTreesMode["error"] === true) {
            checkCanGetOperation();
          } else {
            Object.assign(newData, dataTreesMode);
          }
          canGetSurebetPro.current = true;
          dataTreesMode = null;
        }
        if (JSON.stringify(newData) === JSON.stringify(oldDataJsonConvertted))
          return;

        const combinedData = {
          ...newData,
        };

        let all_keys_sb = Object.keys(combinedData);
        for (let i = 0; i < all_keys_sb.length; i++) {
          let key_sb = all_keys_sb[i];

          let main_data_surebet = combinedData[key_sb]["main"];

          if (
            main_data_surebet !== undefined &&
            "date_time" in main_data_surebet
          ) {
            let time_milliseconds_saved = 0;

            if (localStorage.getItem("t4630564433") !== null) {
              let t4630564433 = JSON.parse(localStorage.getItem("t4630564433"));
              time_milliseconds_saved = t4630564433;
            } else {
              let actual_milliseconds = new Date().getTime();
              localStorage.setItem(
                "t4630564433",
                JSON.stringify(actual_milliseconds),
              );
              time_milliseconds_saved = actual_milliseconds;
            }
            //time_milliseconds_saved -= 1000 * 60 * 30;

            const date = new Date(main_data_surebet["date_time"]);
            const timeInMilliseconds = date.getTime();
            let actual_milliseconds = new Date().getTime();

            let partEquation = actual_milliseconds - timeInMilliseconds;
            let temporaryTimeLaunch = partEquation / (60 * 1000);

            if (time_milliseconds_saved < timeInMilliseconds) {
              let timeLaunch =
                temporaryTimeLaunch > 60
                  ? `${parseInt(temporaryTimeLaunch / 60)} h`
                  : `${parseInt(temporaryTimeLaunch)} min`;
              combinedData[key_sb]["main"]["time"] = timeLaunch;
              continue;
            } else {
              delete combinedData[key_sb];
            }
          }
        }
        let allKeysCombinedData = Object.keys(combinedData);
        let listSurebetToWarnBytime = [];
        for (let i = 0; i < allKeysCombinedData.length; i++) {
          let actualKeySurebet = allKeysCombinedData[i];
          let valueSurebet = combinedData[actualKeySurebet];

          if ("main" in valueSurebet) {
            let allTimeInMilliSeconds = [];
            let mainInfo = valueSurebet["main"];
            for (
              let indexOrderLoop = 0;
              indexOrderLoop < orderloop.length;
              indexOrderLoop++
            ) {
              let order = orderloop[indexOrderLoop];

              if (order in mainInfo && "time_milliseconds" in mainInfo[order]) {
                allTimeInMilliSeconds.push(
                  Number(mainInfo[order]["time_milliseconds"]),
                );
              }
            }

            if (allTimeInMilliSeconds.length > 0) {
              allTimeInMilliSeconds.sort((a, b) => b - a);
              let lastIndexAallTimeInMilliSeconds =
                allTimeInMilliSeconds.length - 1;

              let firstValueFromAallTimeInMilliSeconds =
                allTimeInMilliSeconds[0];
              let lastValueFromAallTimeInMilliSeconds =
                allTimeInMilliSeconds[lastIndexAallTimeInMilliSeconds];

              let calcLimitTime =
                firstValueFromAallTimeInMilliSeconds -
                lastValueFromAallTimeInMilliSeconds;
              if (calcLimitTime >= timeSurebetAllowed) {
                listSurebetToWarnBytime.push(actualKeySurebet);
              }
            }
          }
        }
        setWarningTimeSurebet(listSurebetToWarnBytime);
        let newKeys = Object.keys(newData);
        let oldKeys = Object.keys(oldDataJsonConvertted);

        setFullData(combinedData);
        oldData.current.value =
          typeof newData !== "string" ? JSON.stringify(newData) : newData;

        let storageKeys = [];
        let listKeysToRemove = [];

        for (let i = 0; i < newKeys.length; i++) {
          let valueKey = newKeys[i];
          if (oldKeys.includes(valueKey) === false) {
            storageKeys.push(valueKey);
          }
        }
        for (let i = 0; i < oldKeys.length; i++) {
          let valueKey = oldKeys[i];
          if (newKeys.includes(valueKey) === false) {
            listKeysToRemove.push(valueKey);
          }
        }
        for (let i = 0; i < listKeysToRemove.length; i++) {
          delete oldDataJsonConvertted[listKeysToRemove[i]];
        }

        for (let i = 0; i < storageKeys.length; i++) {
          oldDataJsonConvertted[storageKeys[i]] = newData[storageKeys[i]];
        }

        setNewKeys((prevArray) => [...prevArray, ...storageKeys]);
        setTimeout(function () {
          for (
            let indexNewKeyAdded = 0;
            indexNewKeyAdded < storageKeys.length;
            indexNewKeyAdded++
          ) {
            setNewKeys((keys) => {
              return keys.filter(
                (item) => item !== storageKeys[indexNewKeyAdded],
              );
            });
          }
        }, 10000);
      } catch (error) {
        console.error("Erro na requisição: " + error.message);
      }
    }
  };

  useEffect(() => {
    fetchData();

    const fetchDataInterval = setInterval(async () => {
      await fetchData();
    }, 2000);

    return () => clearInterval(fetchDataInterval);
    // eslint-disable-next-line
  }, [userDatas, entradasLigth, entradasPro, threeHouseEntryisActivated, entradasGlobal]);

  useEffect(() => {
    const fetchDataInterval = setInterval(() => {
      if (popUpBloqueado) {
        setPopUpBloqueado(false);
      }
    }, 60000);

    return () => clearInterval(fetchDataInterval);
  }, [popUpBloqueado]);

  // Memoiza o deep clone de fullData para evitar recriá-lo a cada render quando os dados não mudam
  const parsedFullData = useMemo(() => {
    if (!fullData || Object.keys(fullData).length === 0) {
      return null;
    }
    return JSON.parse(JSON.stringify(fullData));
  }, [fullData]);

  useEffect(() => {
    let newValueData = {};
    if (parsedFullData) {
      let cloneParsedFullData = JSON.parse(JSON.stringify(parsedFullData));
      getResponse(cloneParsedFullData, newValueData);

      if (!apitofisrt) {
        setTimeout(() => {
          setApitoFirst(true);
        }, 10000);
      }
    }
    localStorage.setItem("trash", JSON.stringify(itemsTrash));
    // eslint-disable-next-line
  }, [
    parsedFullData,
    valueMin,
    valueMax,
    betHome,
    quantitySportsEnabled,
    timeEvent,
    itemsTrash,
    statusTrash,
    marketsUnselected,
    blacklistWords,
  ]);

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/");
    }
    // eslint-disable-next-line
  }, [notificationTime, notificationVolume, isLoggedIn]);

  useEffect(() => {
    try {
      setButtonSpreadsheet(
        user.username === "admin" ||
          JSON.parse(user.account_features).includes("planilha") === true,
      );
    } catch {
      console.log("");
    }
  }, [user]);

  function checkUserPlans(dataUser) {
    setAparecerProf(false);
    setAparecerVivo(false);
    setAparecerPro(false);

    const namePlanLower = dataUser.tipo_de_plano.toLowerCase();

    if (namePlanLower.includes("pro ")) {
      setAparecerPro(true);
      setAparecerLight(true);
    } else if (namePlanLower.includes("light")) {
      setentradasPro(false);
      setAparecerLight(true);
    } else if (namePlanLower.includes("vivo")) {
      setentradasPro(false);
      setAparecerVivo(true);
      setAparecerLight(true);
    } else if (namePlanLower.includes("prof")) {
      setAparecerProf(true);
      setAparecerVivo(true);
      setAparecerLight(true);
    }
  }

  useEffect(() => {
    statusMode
      ? (document.body.style.backgroundColor = "#0d0d0d")
      : (document.body.style.backgroundColor = "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusMode]);

  return (
    <>
      <Warn />
      <div
        className={`fontsizemainbet w-100 border border-2 mt-3 ${
          statusMode ? "borderColor" : ""
        } rounded p-0 d-block mx-2`}
      >
        <Row>
          <Col className="borderstyle">
            <div
              className={`py-2 border-bottom ${
                statusMode ? "borderColor textGray" : ""
              } fw-bold text-center `}
              onClick={() => {
                toggleColuna("preEvento");
                isLiveEvent.current = false;
              }}
            >
              <button
                className={`text-title-apostas py-2 border-bottom ${
                  statusMode ? "borderColor textGray" : ""
                } fw-bold text-center MainBets_btn_change_mode`}
                onClick={() => {
                  toggleColuna("preEvento");
                  isLiveEvent.current = false;
                }}
              >
                ARBITRAGENS PRÉ-EVENTO
              </button>
            </div>
          </Col>
          <Col className="borderstyle">
            <div
              className={`py-2 border-bottom ${
                statusMode ? "borderColor textGray" : ""
              } fw-bold text-center`}
              onClick={() => {
                toggleColuna("eventoAoVivo");
                isLiveEvent.current = true;
              }}
            >
              <button
                className={`text-title-apostas py-2 border-bottom ${
                  statusMode ? "borderColor textGray" : ""
                } fw-bold text-center MainBets_btn_change_mode`}
                onClick={() => {
                  toggleColuna("eventoAoVivo");
                  isLiveEvent.current = true;
                }}
              >
                ARBITRAGENS AO VIVO
              </button>
            </div>
          </Col>
          {popUpBloqueado && (
            <div
              style={{
                padding: "20px",
                color: "white",
                background: "red",
                textAlign: "center",
                fontSize: "2rem",
              }}
            >
              <p>
                Pop-up bloqueado! Libere os pop-up do site na parte superior.
              </p>
            </div>
          )}
        </Row>
        <Row>
          {colunaAtiva === "preEvento" && (
            <PreEvento
              statusTrash={statusTrash}
              setStatusTrash={setStatusTrash}
              iconelixeira={iconelixeira}
              controllerLocalStorage={controllerLocalStorage}
              valueMin={valueMin}
              setValueMin={setValueMin}
              valueMax={valueMax}
              setValueMax={setValueMax}
              betHome={betHome}
              setBetHome={setBetHome}
              quantityBetHomeEnabled={quantityBetHomeEnabled}
              setQuantityBetHomeEnabled={setQuantityBetHomeEnabled}
              sports={sports}
              setSports={setSports}
              data={data}
              quantitySportsEnabled={quantitySportsEnabled}
              setQuantitySportsEnabled={setQuantitySportsEnabled}
              timeEvent={timeEvent}
              setTimeEvent={setTimeEvent}
              setlistBehomeEnableds={setlistBehomeEnableds}
              newKeySymbol={newKeySymbol}
              openPopUpCalculator={openPopUpCalculator}
              eventTrash={eventTrash}
              openPopUpBet={openPopUpBet}
              handleClick={handleClick}
              statusMode={statusMode}
              notificationTime={notificationTime}
              setNotificationTime={setNotificationTime}
              setentradasLigth={setentradasLigth}
              entradasLigth={entradasLigth}
              setentradasPro={setentradasPro}
              entradasPro={entradasPro}
              AparecerProf={AparecerProf}
              AparecerVivo={AparecerVivo}
              AparecerLight={AparecerLight}
              AparecerPro={AparecerPro}
              notifyBet={notifyBet}
              filterOrder={filterOrder}
              setFilterOrder={setFilterOrder}
              warningTimeSurebet={warningTimeSurebet}
              requiredBetHome={requiredBetHome}
              setRequiredBetHome={setRequiredBetHome}
              buttonSpreadsheet={buttonSpreadsheet}
            />
          )}
          {colunaAtiva === "eventoAoVivo" && (
            <AoVivo
              statusTrash={statusTrash}
              setStatusTrash={setStatusTrash}
              iconelixeira={iconelixeira}
              controllerLocalStorage={controllerLocalStorage}
              valueMin={valueMin}
              setValueMin={setValueMin}
              valueMax={valueMax}
              setValueMax={setValueMax}
              betHome={betHome}
              setBetHome={setBetHome}
              quantityBetHomeEnabled={quantityBetHomeEnabled}
              setQuantityBetHomeEnabled={setQuantityBetHomeEnabled}
              sports={sports}
              setSports={setSports}
              data={data}
              quantitySportsEnabled={quantitySportsEnabled}
              setQuantitySportsEnabled={setQuantitySportsEnabled}
              timeEvent={timeEvent}
              setTimeEvent={setTimeEvent}
              setlistBehomeEnableds={setlistBehomeEnableds}
              newKeySymbol={newKeySymbol}
              apitofisrt={apitofisrt}
              notifyBet={notifyBet}
              openPopUpCalculator={openPopUpCalculator}
              orderloop={orderloop}
              openPopUpBet={openPopUpBet}
              url={url}
              handleLinkClick={handleLinkClick}
              handleClick={handleClick}
              permissaoaovivo={permissaoaovivo}
              statusMode={statusMode}
              user={user}
              filterOrder={filterOrder}
              setFilterOrder={setFilterOrder}
              requiredBetHome={requiredBetHome}
              setRequiredBetHome={setRequiredBetHome}
              notificationVolume={notificationVolume}
              setentradasLigth={setentradasLigth}
              entradasLigth={entradasLigth}
              setentradasPro={setentradasPro}
              entradasPro={entradasPro}
              AparecerProf={AparecerProf}
              AparecerVivo={AparecerVivo}
              AparecerLight={AparecerLight}
              AparecerPro={AparecerPro}
              buttonSpreadsheet={buttonSpreadsheet}
              checkCanGetOperation={checkCanGetOperation}
            />
          )}
        </Row>
      </div>
    </>
  );
}

export default MainBets;
